import React from "react";
import { useState, useEffect, useRef } from 'react'
import { supabase } from "../supabaseClient";
import { Button, Form, Modal, Row, Alert, ButtonGroup } from "react-bootstrap";
import { Pencil } from 'react-bootstrap-icons';
import InputGroup from 'react-bootstrap/InputGroup';


const ModalForEditProfileMR = (props) => {
    const { selectedRowValues, profileList, whenfinished} = props;
    const profileRef = useRef(null);
    const statusRef = useRef(null);
    const [loading, setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState("");
    const [currentRow, setCurrentRow] = useState(null);

    useEffect(() => {
        const fixCurrentRow = () => {
            let currentRow = null;
            if( selectedRowValues && selectedRowValues.length > 0 && profileList){
                currentRow = profileList.find((element) => element.id === selectedRowValues[0]);
                if(currentRow){
                    console.log("(modalForEdit)Current Row = " + currentRow.id + " - " + currentRow.status + " - " + currentRow.profile );
                    console.log(currentRow);
                } else {
                    //Set to null instead of undefined
                    currentRow = null;
                }
            };
            setCurrentRow(currentRow);
        }
        fixCurrentRow();
    }, [profileList, selectedRowValues]);


    const handleSubmitEditTel = async (e) => {
        e.preventDefault();
        updateInPhonebook();
        if(whenfinished) whenfinished();

    }
            
 /**
* Update one value of a row
*/
 const updateInPhonebook = async () => {

    setLoading(true);
    console.log("Update ItemID = " + selectedRowValues[0]);
    try {
            let { data, error } = await supabase
            .from('phonebook_profiles')
            .update({
                'profile': profileRef.current?.value, 
                'status': statusRef.current?.value, 
             })
            .eq('id', selectedRowValues[0])
            .select()

            if (error) {
                console.warn(error)
            } else if (data) {
                console.log(data);
            }
    } catch (error) {
        console.log("Error in Updating Profile" + error);
    }
    setLoading(false);
}


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Modifier un profile MR
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ?
                                <div class="d-flex p-2 flex-column align-items-center">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="sr-only"></span>
                                    </div>
                                </div> : null}
                <Form onSubmit={handleSubmitEditTel}>
                    <Row className="mb-3">
                        <InputGroup className="mb-3">
                        {/* <InputGroup.Text id="basic-addon1"><IconField iconname={getIconForm().iconName} icontype={getIconForm().iconType} /></InputGroup.Text> */}
                        <InputGroup.Text id="basic-addon2">Titre</InputGroup.Text>
                        <Form.Control type="text" ref={profileRef} defaultValue={currentRow ? currentRow.profile : null} required />
                        </InputGroup>

                        <InputGroup className="mb-3">
                        {/* <InputGroup.Text id="basic-addon1"><IconField iconname={getIconForm().iconName} icontype={getIconForm().iconType} /></InputGroup.Text> */}
                        <InputGroup.Text id="basic-addon3">Status</InputGroup.Text>
                        <Form.Control type="text" ref={statusRef} defaultValue={currentRow ? currentRow.status : null} required />
                        </InputGroup>
                    </Row>
                    {errorMsg && (
                        <Alert
                            variant="danger"
                            onClose={() => setErrorMsg("")}
                            dismissible>
                            {errorMsg}
                        </Alert>
                    )}
                    <div className="text-center mt-2">
                        <ButtonGroup>
                            <Button disabled={loading} type="submit" className="w-50"><Pencil size={32}/>Modifier</Button>
                        </ButtonGroup>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default ModalForEditProfileMR;